import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // We'll create this CSS file next
import runopsLogo from '../assets/Neurealm_Logo_with_Formerly_Color.png'; // Import your local logo

const getDisplayName = (username) => {
    if (!username) return 'User';
    return username.split('@')[0];
};

const Header = ({ user }) => {
    const displayName = getDisplayName(user?.username);
    return (
        <header className="persistent-header">
            {/* The logo is now a separate link, positioned independently */}
            <Link to="/" className="header-logo-link">
                <img src={runopsLogo} alt="RunOps Logo" className="header-logo" />
            </Link>

            {/* The title text is now separate */}
            <div className="header-title-text">
                RunOps AI Automation
            </div>
            
            <div className="header-actions">
                {/* <div className="tabs">
                    <button>Summary</button>
                    <button>Key Metrics</button>
                    <button>Trends</button>
                </div>
                <button className="ask-ai-btn">Ask AI ✨</button> */}
                <div className="user-info">
                    Welcome, {displayName}
                </div>
            </div>
        </header>
    );
};

export default Header;